<template>
  <div class="main-body">
    <div class="header">视频监控</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="success" plain @click="toggleModalViewPlus">视频预览</el-button>

        <div style="float: right;">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right:10px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                @selection-change="handleSelectionChange"
                border >

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="sn" label="序列号"></el-table-column>

        <el-table-column prop="yzm" label="验证码"></el-table-column>

        <el-table-column prop="tdh" label="通道号"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small background layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


      <ViewPlus ref="myViewPlus" v-show="showModalViewPlus" v-on:closeViewPlus="closeViewPlus"></ViewPlus>

    </div>
  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import ViewPlus from "./../Ins/ViewPlus";

export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalViewPlus:false,

      tableData: null,
      totalItems: 0,
      pageSize: 8,
      currentPage: 1,

      th: 0,

      multipleSelection:'',

      arr_ins:[],
      institutionCode: '',

    };
  },
  components: {ViewPlus},
  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalViewPlus:function(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择摄像头'});
        return;
      }

      this.$refs.myViewPlus.init2(this.multipleSelection);
      this.showModalViewPlus = !this.showModalViewPlus;
    },
    closeViewPlus:function(){
      this.showModalViewPlus = !this.showModalViewPlus;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    init(){
      this.getIns();
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    getList(){
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupCamera/PageByInstitutionCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          institutionCode:this.institutionCode,
        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

  },
};
</script>

